module.exports = __webpack_public_path__ + "img/hindu-temple.83745d1e.png";